// EmailJS Configuration

export const EMAIL_CONFIG = {
  SERVICE_ID: 'service_go125hm',
  TEMPLATE_ID: 'template_paui23s',
  PUBLIC_KEY: 'EZEwbYnJ2ZBUcKsX9',
  TO_EMAIL: 'contact@erhrglobal.com'
};
